import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {EMPTY, Observable} from 'rxjs';
import {ConverterOutput, FrontendDocument, FrontendStatusEnum, NachdigalService} from '@nachdigal';
import {catchError} from 'rxjs/operators';
import {DatevNotificationService, DatevNotificationSeverity} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';
import {TaskDataService} from '../service/task-data.service';
import {ComponentHelper} from '../helper/component.helper';
import {LoaderService} from '../service/loader.service';

@Injectable()
export class ConverterOutputResolver implements Resolve<ConverterOutput> {

    constructor(private readonly documentService: NachdigalService,
                private readonly taskDataService: TaskDataService,
                private readonly notificationService: DatevNotificationService,
                private readonly translateService: TranslateService,
                private readonly loadingService: LoaderService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Observable<ConverterOutput> {
        const document: FrontendDocument = route.parent.data.document;
        if (document.status !== FrontendStatusEnum.Created && document.status !== FrontendStatusEnum.SendingError) {
            return null;
        }
        this.notificationService.close('converterError');

        const taskId = route.parent.paramMap.get('taskId');
        const nutzdaten = this.taskDataService.getNutzdaten();

        const appEnum = ComponentHelper.getAppEnum(route);

        const body = JSON.stringify(nutzdaten);
        return this.documentService.convertJsonToXml(taskId, appEnum, body)
            .pipe(
                catchError(() => {
                    this.loadingService.isLoading = {isLoading: false};
                    this.notificationService.showAlert(DatevNotificationSeverity.Error,
                        this.translateService.instant('COMMON_UI.NOTIFICATIONS.CONVERTER_ERROR.TITEL'),
                        null,
                        this.translateService.instant('COMMON_UI.NOTIFICATIONS.CONVERTER_ERROR.MESSAGE'),
                        [{id: 'converterErrorOk', label: 'OK'}],
                        'converterError');
                    return EMPTY;
                })
            );
    }


}
